import React, { useState } from "react";
import { Controller, useFieldArray, useFormContext } from "react-hook-form";
import CustomInput from "../../../Common/CustomInput";
import {
    generateNewChoice,
    multipleChoiceSingleShuffleOptions,
} from "../../../../utils/surveys";
import CustomSelect from "../../../Common/CustomSelect";
import { DeleteFilled, PlusOutlined } from "@ant-design/icons";
import { Checkbox, Typography } from "antd";
import { ErrorMessage } from "@hookform/error-message";

const MultipleChoiceQuestionItem = ({ questionName, questionIndex }) => {
    const [otherOption, setOtherOption] = useState(false);

    const {
        control,
        formState: { errors },
    } = useFormContext();

    const {
        fields: choicesArr,
        append,
        remove,
        update,
    } = useFieldArray({
        control,
        name: `${questionName}.choices`,
        keyName: "rhf_id",
    });

    const changeChoiceHandler = (e, choiceIndex) => {
        update(choiceIndex, {
            ...choicesArr[choiceIndex],
            label: e.target.value,
        });
    };

    const addNewChoiceHandler = () => {
        append(generateNewChoice());
    };

    const deleteChoiceHandler = (choiceIndex) => {
        remove(choiceIndex);
    };

    const addOtherOptionHandler = (e) => {
        const checked = e.target.checked;
        if (checked === true) {
            append({
                id: "other",
                label: "Other",
            });
        } else {
            remove(choicesArr.findIndex((item) => item.id === "other"));
        }
        setOtherOption(checked);
    };

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                gap: "20px",
            }}
        >
            <Controller
                control={control}
                name={`${questionName}.shuffleOption`}
                render={({ field }) => (
                    <CustomSelect
                        style={{ width: "100%" }}
                        errors={errors}
                        label="Shuffle Options"
                        valueKey="value"
                        labelKey="label"
                        options={multipleChoiceSingleShuffleOptions}
                        {...field}
                    />
                )}
            />
            <Typography.Title level={5} style={{ marginBottom: "-10px" }}>
                Options:
            </Typography.Title>
            {errors[`pages`]?.questions?.[questionIndex]?.choices?.message && (
                <div style={{ textAlign: "center" }}>
                    <ErrorMessage
                        errors={errors}
                        name={`questions[${questionIndex}].choices`}
                        render={(data) => (
                            <Typography.Text type="danger">
                                * {data?.message}
                            </Typography.Text>
                        )}
                    />
                </div>
            )}
            {choicesArr.map((choice, index) => (
                <div
                    key={choice.id}
                    style={{
                        display: "flex",
                        gap: "20px",
                        alignItems: "center",
                    }}
                >
                    <Controller
                        control={control}
                        name={`${questionName}.choices[${index}].label`}
                        render={({ field }) => (
                            <CustomInput
                                errors={errors}
                                divProps={{ style: { width: "100%" } }}
                                onChange={(e) => changeChoiceHandler(e, index)}
                                {...field}
                                disabled={choice.id === "other"}
                            />
                        )}
                    />
                    {choice.id !== "other" && (
                        <div
                            style={{
                                display: "flex",
                                gap: "20px",
                            }}
                        >
                            <div>
                                <PlusOutlined onClick={addNewChoiceHandler} />
                            </div>
                            {choicesArr.length > 1 && (
                                <div>
                                    <DeleteFilled
                                        onClick={() =>
                                            deleteChoiceHandler(index)
                                        }
                                    />
                                </div>
                            )}
                        </div>
                    )}
                </div>
            ))}
            <Checkbox onChange={addOtherOptionHandler} checked={otherOption}>
                Add "Other" option
            </Checkbox>
        </div>
    );
};

export default MultipleChoiceQuestionItem;
